$(function () {
	$('.js-input-file').change(function (e) {
		let uploadFileName = e.target.files[0].name;
		let inputFileName = $(this).closest('.file').find('.file__name');

		inputFileName.text(uploadFileName);
		if (this.value != '') {
			$(this).closest('.file').addClass('file_active');
		} else {
			$(this).closest('.file').removeClass('file_active');
		}
	});

	$('.js-input-file-delete').click(function (e) {
		e.preventDefault();
		$(this).closest('.file').removeClass('file_active').find('.js-input-file').val('');
	});
})